export const MY_FOLDER_PATHNAME = '/folders/owned';
export const SHARED_FOLDER_PATHNAME = '/folders/shared';
export const FAVORITE_FOLDER_PATHNAME = '/favorite/favorite-folders';
